import axios from 'axios'

export const offer = {
    state:{
        Offers:[],
        OffersAll:[],
        OfferById:{},
        BtcRate: null
    },
    mutations:{
        SetOffers(state, data){
            state.Offers = data
        },
        SetOffersAll(state, data){
            state.OffersAll = data
        },
        SetOfferById(state, data){
            state.OfferById = data
        },
        SetBtcRate(state, data){
            state.BtcRate = data.rate_float
        }
    },
    actions:{
        GetOffers: ({commit}, payload) => {
            return new Promise((resolve, reject)=>{
                axios.get(`/useroffer?type=${payload.type}&from=${payload.from}&to=${payload.to}&country=${payload.country}`)
                .then(({data, status})=>{
                    if(status === 200){
                        commit('SetOffers', data)
                        resolve(data);
                    }else if (status===204){
                        console.log('data empty')
                        let data = []
                        commit('SetOffers', data)
                        resolve(data)
                    }
                })
                .catch((error)=>{
                    reject(error);
                });
            })
        },
        GetOffersAll: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            // axios.get('/nonuseroffer')
            axios.get(`/nonuseroffer?type=${payload.type}&from=${payload.from}&to=${payload.to}&country=${payload.country}`)
            .then(({data, status})=>{
                console.log(data)
                if(status === 200){
                commit('SetOffersAll', data)
                resolve(data);
                }else if (status===204){
                    console.log('data empty')
                    let data = []
                    commit('SetOffersAll', data)
                    resolve(data)
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        GetOfferById: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.get("/itemsoffer/"+payload)
            .then(({data, status})=>{
                if(status === 200){
                commit('SetOfferById', data)
                resolve(data);
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        AcceptOffer: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.get("/temporaryacceptoffer/"+payload)
            .then(({data, status})=>{
                if(status === 200){
                resolve(data);               
                commit()
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        GetBtcRate: ({commit}) => {
            return new Promise((resolve, reject)=>{
            axios.get("/btcrate")
            .then(({data, status})=>{
                if(status === 200){
                commit('SetBtcRate', data)
                resolve(data);
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },
        CancelOrder: ({commit},payload) => {
            return new Promise((resolve, reject)=>{
            axios.get("/canceltemporaryoffer/"+payload)
            .then(({data, status})=>{
                if(status === 200){
                    resolve(data);                
                    commit()
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },   
        ModifyOfferFinal: ({commit}, payload) => {
            return new Promise((resolve, reject)=>{
            axios.post("/modifyoffer",payload)
            .then(({data, status})=>{
                if(status === 200){
                    resolve(data);
                    commit()
                }
            })
            .catch((error)=>{
                reject(error);
            });
            })
        },     
    }
}
